export default {"src":"/_next/static/media/SliderLeft.4797e943.svg","height":23,"width":13,"blurWidth":0,"blurHeight":0};